export default __webpack_public_path__ + "static/media/pic-5.ca232c8f.jpg";